/**
 * Notification data model – ready for backend (e.g. Supabase + Realtime).
 */
export type NotificationType =
  | 'like'
  | 'comment'
  | 'share'
  | 'new_photo'
  | 'new_post'
  | 'friend_request'
  | 'mention'
  | 'system';

export type NotificationEntityType = 'post' | 'photo' | 'profile' | 'comment';

export interface Notification {
  id: string;
  recipientUserId: string;
  actorUserId: string;
  actorName: string;
  actorAvatar: string; // emoji or URL
  type: NotificationType;
  entityId: string | null;
  entityType: NotificationEntityType | null;
  message: string;
  isRead: boolean;
  createdAt: string; // ISO
}

export function formatNotificationTime(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffM = Math.floor(diffMs / 60000);
  const diffH = Math.floor(diffMs / 3600000);
  const diffD = Math.floor(diffMs / 86400000);
  if (diffM < 1) return 'Just now';
  if (diffM < 60) return `${diffM}m ago`;
  if (diffH < 24) return `${diffH}h ago`;
  if (diffD < 7) return `${diffD}d ago`;
  return d.toLocaleDateString();
}
